import React from 'react';
import { Button } from '@youngcapital/component-library';
import { v4 as uuidv4 } from 'uuid';
import { FIELDSET_PROPTYPES } from '../asFieldset';
import WorkExperience from './WorkExperience';
import { addEntry, removeEntry } from '../helpers/utils';

const INITIAL_VALUES = {
  company: '',
  function_title: '',
  city: '',
  date_start: '',
  date_end: '',
  current_job: false
};

class WorkExperiences extends React.Component {
  fieldName = 'work_experiences';

  componentDidMount() {
    const { getFieldProps } = this.props;
    const { value } = getFieldProps('work_experiences');
    if (value.length) return;
    this.addWorkExperience();
  }

  addWorkExperience = () =>
    addEntry({
      fieldProps: this.props.getFieldProps(this.fieldName),
      initialValues: {
        _id: uuidv4(),
        ...INITIAL_VALUES
      }
    });

  removeWorkExperience = key =>
    removeEntry({
      fieldProps: this.props.getFieldProps(this.fieldName),
      key
    });

  render() {
    const { getFieldProps, t } = this.props;
    const { value } = getFieldProps('work_experiences');
    const isOnlyField = value.length === 1;

    return (
      <>
        {value.map(({ _id }, index) => (
          <WorkExperience
            index={index}
            key={_id}
            getFieldProps={getFieldProps}
            t={t}
            isOnlyField={isOnlyField}
            removeWorkExperience={() => this.removeWorkExperience(_id)}
          />
        ))}
        <div className='mt-2x'>
          <Button
            type='button'
            variant='tertiary'
            onClick={this.addWorkExperience}
            title='add-work-experience-button'
          >
            {t('cv_fieldset.work_experiences.add_work_experience')}
          </Button>
        </div>
      </>
    );
  }
}

WorkExperiences.propTypes = FIELDSET_PROPTYPES;

export default WorkExperiences;
